var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("SelectInline", {
    attrs: {
      "nothing-allowed": {
        enabled: false,
        nextLevelText: "Alle Regionen/Bezirke möglich"
      },
      "fan-config": {
        nothingAllowed: {
          textPerLevel: {
            1: "Alle Regionen/Bezirke möglich"
          }
        },
        groupByLetter: {
          enabled: true,
          condition: {
            characteristicHasNotLabel: "Wien"
          }
        },
        characteristicMetaProperty: "geo",
        withKeyword: true,
        searchConfig: {
          type: _vm.searchTypeStartsWith
        },
        showMultipleHint: true,
        titleFormats: {
          level: {
            1: "%title%: in welchen Regionen/Bezirken?"
          }
        },
        maxLevel: 1
      },
      "characteristic-type": _vm.meta.geoType,
      "characteristic-items": _vm.geoItems,
      "initial-show-all": "",
      "show-multiple-hint": "",
      "label-type": "application"
    },
    on: { input: _vm.emitChangeEvent },
    model: {
      value: _vm.geo,
      callback: function($$v) {
        _vm.geo = $$v
      },
      expression: "geo"
    }
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }